import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../../context/AuthContext';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../../../../../firebase';

const SubCategories = ({ category }) => {
  const { user } = useAuth();
  const { bid } = user.claims;

  const [data, setData] = useState(null);

  const getSubCategories = (categoryID) => {
    const q = query(collection(db, "Businesses", bid, "ExpenseCategories", categoryID, "SubCategories"), orderBy('name'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });

      setData(tempData);
    }, (error) => {
      console.log(error.message);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    if (category) {
      getSubCategories(category.id);
    }
  }, []);

  return (
    <>
      {
        data && data.map((item) => item.name).join(", ")
      }
    </>
  )
}

export default SubCategories;
